// Continuous loop animation slider, shared by #our_clients and #trusted-tools
jQuery(document).ready(function () {
  function initContinuousSlider(options) {
    var container = document.querySelector(options.container);
    if (!container) return;

    var autoWrapTrack = !!options.autoWrapTrack;
    var track = autoWrapTrack ? null : document.querySelector(options.track);
    if (!autoWrapTrack && !track) return;

    var speedPxPerSecond = options.speed || 40;
    var mediaQuery = options.mediaQuery ? window.matchMedia(options.mediaQuery) : null;

    var isActive = false;
    var offset = 0;
    var rafId = null;
    var lastTime = 0;
    var isVisible = false;
    var isPaused = false;
    var isHovering = false;
    var isDragging = false;
    var activePointerId = null;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var lastDragX = 0;
    var lastDragTime = 0;
    var momentumVelocity = 0;
    var isMomentumActive = false;
    var momentumDecayPerFrame = 0.92;
    var minMomentumVelocity = 10;
    var observer = null;
    var originalChildren = null;

    function updatePauseState() {
      isPaused = isHovering || isDragging;
    }

    function getLoopWidth() {
      return track.scrollWidth / 2;
    }

    function normalizeOffset() {
      var loopWidth = getLoopWidth();
      if (!loopWidth) return;

      offset = ((offset % loopWidth) + loopWidth) % loopWidth;
    }

    function render() {
      track.style.transform = "translate3d(" + -offset + "px, 0, 0)";
    }

    function tick(timestamp) {
      if (!lastTime) lastTime = timestamp;

      var deltaSeconds = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      if (isVisible) {
        if (isMomentumActive && !isDragging) {
          offset += momentumVelocity * deltaSeconds;
          momentumVelocity *= Math.pow(momentumDecayPerFrame, deltaSeconds * 60);

          if (Math.abs(momentumVelocity) < minMomentumVelocity) {
            momentumVelocity = 0;
            isMomentumActive = false;
          }

          normalizeOffset();
          render();
        } else if (!isPaused && !isDragging) {
          offset += speedPxPerSecond * deltaSeconds;
          normalizeOffset();
          render();
        }
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function startAnimation() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(tick);
    }

    function stopAnimation() {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      lastTime = 0;
    }

    function startDrag(clientX) {
      isDragging = true;
      isMomentumActive = false;
      momentumVelocity = 0;
      dragStartX = clientX;
      dragStartOffset = offset;
      lastDragX = clientX;
      lastDragTime = performance.now();
      updatePauseState();
      container.style.cursor = "grabbing";
    }

    function moveDrag(clientX) {
      if (!isDragging) return;

      var now = performance.now();
      var deltaX = clientX - lastDragX;
      var deltaTime = (now - lastDragTime) / 1000;

      if (deltaTime > 0) {
        // Smoothed velocity in px/s for momentum when user releases drag.
        var currentVelocity = -deltaX / deltaTime;
        momentumVelocity = momentumVelocity * 0.25 + currentVelocity * 0.75;
      }

      lastDragX = clientX;
      lastDragTime = now;

      var delta = clientX - dragStartX;
      offset = dragStartOffset - delta;
      normalizeOffset();
      render();
    }

    function endDrag() {
      if (Math.abs(momentumVelocity) >= minMomentumVelocity) {
        isMomentumActive = true;
      } else {
        momentumVelocity = 0;
        isMomentumActive = false;
      }

      isDragging = false;
      activePointerId = null;
      updatePauseState();
      container.style.cursor = "grab";
    }

    function onMouseEnter() {
      isHovering = true;
      updatePauseState();
      container.style.cursor = "grab";
    }

    function onMouseLeave() {
      isHovering = false;
      updatePauseState();
    }

    function onPointerDown(e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      activePointerId = e.pointerId;
      container.setPointerCapture(activePointerId);
      startDrag(e.clientX);
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;

      e.preventDefault();
      moveDrag(e.clientX);
    }

    function onPointerUp(e) {
      if (e.pointerId !== activePointerId) return;

      container.releasePointerCapture(activePointerId);
      endDrag();
    }

    function onPointerCancel(e) {
      if (e.pointerId !== activePointerId) return;

      endDrag();
    }

    function activate() {
      if (isActive) return;
      isActive = true;

      if (autoWrapTrack) {
        originalChildren = Array.prototype.slice.call(container.children);

        track = document.createElement("div");
        track.className = options.trackClassName;
        track.style.gap = window.getComputedStyle(container).gap;

        originalChildren.forEach(function (child) {
          track.appendChild(child);
        });
        container.appendChild(track);

        if (options.activeClassName) container.classList.add(options.activeClassName);
      }

      // Duplicate once to allow a seamless loop when crossing the midpoint.
      track.insertAdjacentHTML("beforeend", track.innerHTML);

      offset = 0;
      render();

      container.style.cursor = "grab";
      container.addEventListener("mouseenter", onMouseEnter);
      container.addEventListener("mouseleave", onMouseLeave);
      container.addEventListener("pointerdown", onPointerDown);
      container.addEventListener("pointermove", onPointerMove);
      container.addEventListener("pointerup", onPointerUp);
      container.addEventListener("pointercancel", onPointerCancel);

      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) startAnimation();
        });
      });
      observer.observe(container);
    }

    function deactivate() {
      if (!isActive) return;
      isActive = false;

      stopAnimation();
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      container.removeEventListener("mouseenter", onMouseEnter);
      container.removeEventListener("mouseleave", onMouseLeave);
      container.removeEventListener("pointerdown", onPointerDown);
      container.removeEventListener("pointermove", onPointerMove);
      container.removeEventListener("pointerup", onPointerUp);
      container.removeEventListener("pointercancel", onPointerCancel);

      isHovering = false;
      isDragging = false;
      isMomentumActive = false;
      momentumVelocity = 0;
      offset = 0;
      container.style.cursor = "";

      if (autoWrapTrack) {
        if (options.activeClassName) container.classList.remove(options.activeClassName);
        track.remove();
        originalChildren.forEach(function (child) {
          container.appendChild(child);
        });
        track = null;
      } else {
        track.style.transform = "";
      }
    }

    if (mediaQuery) {
      var handleBreakpointChange = function (e) {
        if (e.matches) {
          activate();
        } else {
          deactivate();
        }
      };
      handleBreakpointChange(mediaQuery);
      mediaQuery.addEventListener("change", handleBreakpointChange);
    } else {
      activate();
    }
  }

  initContinuousSlider({
    container: "#our_clients",
    track: "#our_clients .wp-block-post-template",
  });

  initContinuousSlider({
    container: "#trusted-tools",
    autoWrapTrack: true,
    trackClassName: "trusted-tools-track",
    activeClassName: "is-slider-active",
    mediaQuery: "(max-width: 1199px)",
  });
});
